var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUngTruocTienBan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.465 4.626c.645 0 1.17.524 1.167 1.17v3.193h-6.944c-.08 0-.159.005-.236.015-.464.053-.878.269-1.186.587-.35.358-.564.847-.564 1.385v2.602c0 1.097.891 1.988 1.988 1.988h6.942v3.264c0 .646-.524 1.17-1.17 1.17H1.17C.524 20 0 19.476 0 18.83V5.796c0-.105.016-.208.042-.307.042-.156.117-.3.215-.423.216-.27.546-.44.915-.44zm1.2 5.175c.133 0 .26.024.379.064.154.053.292.135.41.243.233.213.38.522.38.863v2.604c0 .342-.147.65-.38.864-.118.107-.256.191-.41.243-.12.04-.246.063-.379.063H12.69c-.645 0-1.17-.524-1.17-1.17v-2.604c0-.646.525-1.17 1.17-1.17zm-5.117 1.732h-.388c-.136 0-.26.049-.36.126-.139.105-.225.271-.225.459v.388c0 .323.262.585.585.585h.388c.323 0 .585-.262.585-.585v-.388c0-.323-.262-.585-.585-.585zM11.168.123c.577-.289 1.28-.05 1.567.528l.44.889-8.306 2.267H3.732zm4.585 1.482c.515 0 .987.342 1.128.864l.365 1.338H7.534l5.959-1.626 1.951-.533c.103-.028.206-.043.309-.043z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUngTruocTienBan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_ung-truoc-tien-ban.5e23a0f1.svg";
export { ForwardRef as ReactComponent };